import React, { memo } from 'react';
export function HowToUse() {
  return <section className="py-12 bg-green-50 rounded-lg" data-id="element-135">
      <div className="max-w-3xl mx-auto" data-id="element-136">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-green-800 mb-8" data-id="element-137">
          How Banisteriopsis Caapi Supports the Body Naturally
        </h2>
        <div className="my-8" data-id="element-138">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/s2Nb8Ukr8TWWtJLe5DztyV/ChatGPT_Image_Jun_27%2C_2025%2C_11_34_06_AM.png" alt="Indigenous healer with traditional plant medicine" className="mx-auto rounded-lg shadow-lg max-w-full" data-id="element-139" />
          <p className="text-sm text-center text-gray-600 mt-2" data-id="element-140">
            Indigenous wisdom and traditional healing with Banisteriopsis caapi
          </p>
        </div>
        <p className="text-xl mb-6" data-id="element-141">
          This plant contains natural compounds known as harmala alkaloids,
          which:
        </p>
        <ul className="space-y-4 mb-8" data-id="element-142">
          <li className="flex items-start" data-id="element-143">
            <svg className="h-6 w-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-144">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-145"></path>
            </svg>
            <span className="text-xl" data-id="element-146">
              Act as gentle MAO-A modulators — helping the body regulate
              neurotransmitters like serotonin and dopamine
            </span>
          </li>
          <li className="flex items-start" data-id="element-147">
            <svg className="h-6 w-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-148">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-149"></path>
            </svg>
            <span className="text-xl" data-id="element-150">
              Support emotional flexibility — so you're less reactive and more
              grounded when stress shows up
            </span>
          </li>
          <li className="flex items-start" data-id="element-151">
            <svg className="h-6 w-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-152">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-153"></path>
            </svg>
            <span className="text-xl" data-id="element-154">
              May help promote brain-derived neurotrophic factor (BDNF) — a key
              compound in learning, memory, and emotional balance
            </span>
          </li>
          <li className="flex items-start" data-id="element-155">
            <svg className="h-6 w-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-156">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-157"></path>
            </svg>
            <span className="text-xl" data-id="element-158">
              Support the parasympathetic nervous system — the "rest and
              restore" part of the body that often gets stuck offline when we're
              in chronic stress
            </span>
          </li>
        </ul>
        <p className="text-xl font-bold mb-6" data-id="element-159">But here's the key:</p>
        <p className="text-xl mb-6" data-id="element-160">Aya Caps won't make you "trip."</p>
        <p className="text-xl mb-6" data-id="element-161">
          So they're non-psychedelic, legal in almost every U.S. state, and safe
          to take in daily life (as long as you follow normal dietary
          precautions for MAO-A supplements).
        </p>
        <p className="text-xl mb-6" data-id="element-162">You can take them before work.</p>
        <p className="text-xl mb-6" data-id="element-163">Before journaling.</p>
        <p className="text-xl mb-6" data-id="element-164">Before meditation.</p>
        <p className="text-xl mb-6" data-id="element-165">
          Or simply as part of your regular routine.
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-center text-green-800 my-8" data-id="element-166">
          Aya Caps isn't a stimulant or a sedative.
        </h2>
        <p className="text-xl mb-6" data-id="element-167">
          Most people describe the experience like this:
        </p>
        <ul className="space-y-4 mb-8" data-id="element-168">
          <li className="flex items-start" data-id="element-169">
            <svg className="h-6 w-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-170">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-171"></path>
            </svg>
            <span className="text-xl" data-id="element-172">
              "I just feel a little more connected."
            </span>
          </li>
          <li className="flex items-start" data-id="element-173">
            <svg className="h-6 w-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-174">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-175"></path>
            </svg>
            <span className="text-xl" data-id="element-176">"I don't spiral as easily."</span>
          </li>
          <li className="flex items-start" data-id="element-177">
            <svg className="h-6 w-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-178">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-179"></path>
            </svg>
            <span className="text-xl" data-id="element-180">
              "I notice I can take a deeper breath."
            </span>
          </li>
          <li className="flex items-start" data-id="element-181">
            <svg className="h-6 w-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-182">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-183"></path>
            </svg>
            <span className="text-xl" data-id="element-184">
              "It's like I have more space in my day."
            </span>
          </li>
        </ul>
        <p className="text-xl mb-6" data-id="element-185">
          It may take a few days or weeks for you to notice the full benefits.
        </p>
        <p className="text-xl mb-6" data-id="element-186">
          That's because it works gradually — with consistency.
        </p>
        <p className="text-xl mb-6" data-id="element-187">
          Think of it like yoga for your nervous system.
        </p>
        <p className="text-xl mb-6" data-id="element-188">
          The more you show up, the stronger the foundation becomes.
        </p>
        <div className="mt-10 text-sm text-gray-600 bg-gray-100 p-4 rounded-lg" data-id="element-189">
          <p data-id="element-190">
            † This product contains Banisteriopsis caapi, which is a natural
            Monoamine Oxidase Inhibitor (MAOI). Before taking this supplement,
            please consult with your healthcare provider, especially if you are
            taking any other medications, as MAOIs can interact with certain
            drugs, including antidepressants and certain pain medications. Do
            not use this supplement if you are taking psychiatric medications or
            have a history of mental health disorders unless under the direct
            supervision of a qualified healthcare professional.
          </p>
          <p className="mt-2" data-id="element-191">
            These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease.
          </p>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-center text-green-800 my-8" data-id="element-192">
          What's Inside (And What's Not)
        </h2>
        <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-193">
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-194">
            <h3 className="text-xl font-bold mb-4 text-green-700" data-id="element-195">
              What's Inside:
            </h3>
            <ul className="space-y-2" data-id="element-196">
              <li className="flex items-start" data-id="element-197">
                <svg className="h-5 w-5 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-198">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-199"></path>
                </svg>
                <span className="text-lg" data-id="element-200">
                  100% Banisteriopsis caapi vine (ethically wildcrafted)
                </span>
              </li>
              <li className="flex items-start" data-id="element-201">
                <svg className="h-5 w-5 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-202">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-203"></path>
                </svg>
                <span className="text-lg" data-id="element-204">Vegetable cellulose capsule</span>
              </li>
              <li className="flex items-start" data-id="element-205">
                <svg className="h-5 w-5 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-206">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-207"></path>
                </svg>
                <span className="text-lg" data-id="element-208">
                  A tiny amount of rice flour to ensure capsule consistency
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-209">
            <h3 className="text-xl font-bold mb-4 text-red-700" data-id="element-210">
              What's Not Inside:
            </h3>
            <ul className="space-y-2" data-id="element-211">
              <li className="flex items-start" data-id="element-212">
                <svg className="h-5 w-5 text-red-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-213">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-214"></path>
                </svg>
                <span className="text-lg" data-id="element-215">No Tripping</span>
              </li>
              <li className="flex items-start" data-id="element-216">
                <svg className="h-5 w-5 text-red-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-217">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-218"></path>
                </svg>
                <span className="text-lg" data-id="element-219">No synthetic additives</span>
              </li>
              <li className="flex items-start" data-id="element-220">
                <svg className="h-5 w-5 text-red-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-221">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-222"></path>
                </svg>
                <span className="text-lg" data-id="element-223">
                  No fillers, preservatives, or sugars
                </span>
              </li>
              <li className="flex items-start" data-id="element-224">
                <svg className="h-5 w-5 text-red-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-225">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-226"></path>
                </svg>
                <span className="text-lg" data-id="element-227">No psychoactive effects</span>
              </li>
              <li className="flex items-start" data-id="element-228">
                <svg className="h-5 w-5 text-red-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-229">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-230"></path>
                </svg>
                <span className="text-lg" data-id="element-231">
                  Not intended to treat or diagnose any condition
                </span>
              </li>
            </ul>
          </div>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-center text-green-800 my-8" data-id="element-232">
          How to Use Aya Caps
        </h2>
        <p className="text-xl mb-6" data-id="element-233">We recommend starting with:</p>
        <ul className="space-y-4 mb-8" data-id="element-234">
          <li className="flex items-start" data-id="element-235">
            <svg className="h-6 w-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-236">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-237"></path>
            </svg>
            <span className="text-xl" data-id="element-238">1 capsule, 3 times per week</span>
          </li>
          <li className="flex items-start" data-id="element-239">
            <svg className="h-6 w-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-240">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-241"></path>
            </svg>
            <span className="text-xl" data-id="element-242">On non-consecutive days</span>
          </li>
          <li className="flex items-start" data-id="element-243">
            <svg className="h-6 w-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-244">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-245"></path>
            </svg>
            <span className="text-xl" data-id="element-246">With or without food</span>
          </li>
        </ul>
        <p className="text-xl mb-6" data-id="element-247">
          Once your body adjusts, some people choose to take it once daily.
        </p>
        <p className="text-xl mb-6" data-id="element-248">As always, it's important to:</p>
        <ul className="space-y-4 mb-8" data-id="element-249">
          <li className="flex items-start" data-id="element-250">
            <svg className="h-6 w-6 text-yellow-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-251">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-252"></path>
            </svg>
            <span className="text-xl" data-id="element-253">
              Avoid combining with alcohol or high-tyramine foods (like aged
              cheese, cured meats, or fermented foods)
            </span>
          </li>
          <li className="flex items-start" data-id="element-254">
            <svg className="h-6 w-6 text-yellow-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-255">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-256"></path>
            </svg>
            <span className="text-xl" data-id="element-257">Avoid combining with other MAOIs</span>
          </li>
          <li className="flex items-start" data-id="element-258">
            <svg className="h-6 w-6 text-yellow-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-259">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-260"></path>
            </svg>
            <span className="text-xl" data-id="element-261">
              Consult your healthcare provider if you're taking medications or
              managing health conditions
            </span>
          </li>
        </ul>
        <p className="text-xl mb-6" data-id="element-262">
          Aya Caps is designed for gentle, mindful use.
        </p>
        <p className="text-xl mb-6" data-id="element-263">
          It's about building a deeper relationship with your body, not
          overpowering it.
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-center text-green-800 my-8" data-id="element-264">
          Our Commitment: Protecting the Forest That Taught Us
        </h2>
        <p className="text-xl mb-6" data-id="element-265">
          We're proud to source our vine ethically and in collaboration with
          local communities in the Amazon.
        </p>
        <p className="text-xl mb-6" data-id="element-266">
          And with every bottle sold, we help support reforestation and
          indigenous preservation efforts through our trusted charity partners.
        </p>
        <p className="text-xl mb-6" data-id="element-267">
          Because healing ourselves shouldn't come at the cost of the land that
          taught us how.
        </p>
        <div className="mt-10 text-center" data-id="element-268">
          <a href="#pricing-section" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg text-xl transition duration-300 shadow-lg inline-block" onClick={e => {
          e.preventDefault();
          document.getElementById('pricing-section')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-269">
            Try Aya Caps Today
          </a>
        </div>
      </div>
    </section>;
}